import domains from '../containers/Domains';

export const creds = domains.CABusinessId;

export const fbInitSDK = () => {
  window.fbAsyncInit = function() {
    window.FB.init({
      appId: domains.alexiaAppId,
      autoLogAppEvents: true,
      xfbml: true,
      version: domains.fbVersion
    });

    window.FB.Event.subscribe('auth.statusChange', (response) => {
      if (response.authResponse) {
        this.updateLoggedInState(response);
      } else {
        this.updateLoggedOutState();
      }
    });
  }.bind(this);

  (function(d, s, id) {
    const fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      return;
    }
    const js = d.createElement(s);
    js.id = id;
    js.src = 'https://connect.facebook.net/en_US/sdk.js';
    fjs.parentNode.insertBefore(js, fjs);
  })(document, 'script', 'facebook-jssdk');
};

class FBAdOps {
  constructor() {
    console.log('creating FBAdOps');
  }
}

export default new FBAdOps();



// WEBPACK FOOTER //
// ./src/config/FBAdOps.js